import { render, staticRenderFns } from "./AttributeFilters.vue?vue&type=template&id=06612753&scoped=true"
import script from "./AttributeFilters.vue?vue&type=script&lang=ts"
export * from "./AttributeFilters.vue?vue&type=script&lang=ts"
import style0 from "./AttributeFilters.vue?vue&type=style&index=0&id=06612753&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06612753",
  null
  
)

export default component.exports